const projects = [
  {
    id: 1,
    title: "FolioForge.ai - Scalable SaaS Platform",
    description:
      "Architected a highly scalable, multi-tenant SaaS utilizing Clean Architecture and CQRS, deploying RabbitMQ worker pipelines to asynchronously decouple high-latency AI parsing tasks from core API threads. Engineered robust system resilience by implementing custom Circuit Breaker and Bulkhead patterns for external LLMs, alongside OpenTelemetry for distributed tracing and EF Core global query filters for secure data isolation.",
    techStack: ["React", ".NET 9", "RabbitMQ", "Docker"],
    github: "https://github.com/Shivansh-Gaur2/FolioForge.ai",
    image:
      "https://res.cloudinary.com/dvg1qyd4b/image/upload/v1741704880/Screenshot_2025-03-11_202348_hrqubs.png",
    video: "",
  },
  {
    id: 2,
    title: "Rural Credit FinTech Engine (AI for Bharat)",
    description:
      "Architected a highly scalable, event-driven backend utilizing Clean Architecture to deploy 8 independent FastAPI microservices, decoupling domain events via AWS SNS/SQS and persisting state in DynamoDB. Engineered an algorithmic 8-factor risk scoring and cash-flow forecasting engine for volatile financial data, utilizing property-based testing (Hypothesis) to rigorously validate complex financial edge cases.",
    techStack: ["Python", "FastAPI", "DynamoDB", "AWS SNS/SQS"],
    github: "https://github.com/Shivansh-Gaur2/AiForBharatHack",
    image:
      "https://res.cloudinary.com/dvg1qyd4b/image/upload/v1776143807/Screenshot_2026-04-14_104623_cunsqo.png",
    video:
      "https://res.cloudinary.com/dvg1qyd4b/video/upload/v1776143641/Screen_Recording_2026-03-09_232441_1_1_pbyipi.mp4",
  },
  {
    id: 3,
    title: "TeamTalk-AI - Collaborative Workspace",
    description:
      "Engineered a low-latency collaborative platform supporting concurrent users via WebSockets for real-time state synchronization, efficiently managing rapid continuous data streams. Tuned MongoDB indexing and aggregation pipelines for write-heavy traffic, achieving reliable sub-second message delivery at scale.",
    techStack: ["React", "Node.js", "WebSocket", "MongoDB"],
    github: "https://github.com/Shivansh-Gaur2/TeamTalk-AI",
    image:
      "https://res.cloudinary.com/dvg1qyd4b/image/upload/v1741704880/Screenshot_2025-03-11_202348_hrqubs.png",
    video:
      "https://res.cloudinary.com/dvg1qyd4b/video/upload/v1741704709/Chat_demo_ktwtha.mp4",
  },
  {
    id: 4,
    title: "Blog Application",
    description:
      "A scalable blogging platform with authentication and pagination.",
    techStack: ["React.js", "Express.js", "MongoDB"],
    github: "https://github.com/Shivansh-Gaur2/Blog-APP",
    image:
      "https://res.cloudinary.com/dvg1qyd4b/image/upload/v1741705373/Screenshot_2025-03-11_203200_mopv3j.png",
    video:
      "https://res.cloudinary.com/dvg1qyd4b/video/upload/v1741705160/blog_dkxjlp.mp4",
  },
];

export default projects;
  